import { render, staticRenderFns } from "./area-selection.vue?vue&type=template&id=2ba6019a&scoped=true"
import script from "./area-selection.vue?vue&type=script&lang=ts"
export * from "./area-selection.vue?vue&type=script&lang=ts"
import style0 from "./area-selection.vue?vue&type=style&index=0&id=2ba6019a&prod&lang=less"
import style1 from "./area-selection.vue?vue&type=style&index=1&id=2ba6019a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6019a",
  null
  
)

export default component.exports